import { useEffect, useState } from 'react';
// eslint-disable-next-line import/no-named-as-default
import useFetch from 'use-http';
import { apiUsers } from 'constants/api';

// Task 34 — GET users/me/additional-exports: export addizionali effettivi
// dell'utente loggato (singolo ponte + multi-ponte), già espansi con la
// gerarchia padre→figli dal BE. Stessa risposta per un principale e per un
// suo collaboratore interno (il BE risale da sé al principale). Condiviso
// tra ExportSelect.jsx, ExportStructuresPanel.jsx e StructuresList.jsx per
// non ripetere la stessa fetch in tre punti.
//
// `get()` imperativo dentro un useEffect + useState locale, non la modalità
// dichiarativa `useFetch(url, {}, [])`: verificato in pratica che quest'ultima,
// in questo punto dell'albero di componenti, risolve correttamente `data` ma
// non fa ripartire in modo affidabile il render di chi la consuma — serviva
// un'interazione scollegata (selezionare un'altra voce della tendina) perché
// l'elenco si aggiornasse. useState con setData esplicito non ha questo problema.
export function useMyAdditionalExportsFetch() {
  const { get } = useFetch();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const result = await get(apiUsers.ME_ADDITIONAL_EXPORTS);
        if (isMounted) setData(result);
      } finally {
        if (isMounted) setLoading(false);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, []);

  return { loading, data };
}
